import React, { forwardRef, useImperativeHandle, useRef } from 'react';
import PropTypes from 'prop-types';

// TODO: React v19 will not need `forwardRef` https://react.dev/reference/react/forwardRef

/**
 * @param {object} props
 * @param {Function} props.onConfirm - Function to call when removal confirmation clicked
 * @param {number} props.selectedCount - Number of duplicates that will be removed
 */
const ConfirmationModal = forwardRef(
  ({ onConfirm, selectedCount = 0 }, ref) => {
    const modalRef = useRef(null);

    // expose `open` function to allow parent to display modal
    useImperativeHandle(ref, () => ({
      open: () => {
        if (modalRef.current) {
          $(modalRef.current).modal('show');
        }
      },
    }));

    return (
      <div
        className="modal fade duplicate-photo-confirmation-modal"
        ref={modalRef}>
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-heading">
              <h4 className="modal-title w-100 text-center">Confirm Removal</h4>
            </div>
            <div className="modal-body text-center mt-2">
              <p>
                {`${selectedCount} duplicate photo${
                  selectedCount === 1 ? '' : 's'
                } will be removed`}
              </p>
            </div>
            <div className="modal-footer justify-content-center">
              <div className="row w-100">
                <div className="col">
                  <button
                    className="btn btn-outline-info rounded-pill btn-block"
                    data-dismiss="modal">
                    Cancel
                  </button>
                </div>
                <div className="col">
                  <button
                    className="btn btn-primary rounded-pill btn-block"
                    data-dismiss="modal"
                    onClick={onConfirm}>
                    Remove Duplicates
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  },
);

ConfirmationModal.displayName = 'ConfirmationModal';

ConfirmationModal.propTypes = {
  onConfirm: PropTypes.func.isRequired,
  selectedCount: PropTypes.number.isRequired,
};

export { ConfirmationModal };
